"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("./Input"));

var _Icon = _interopRequireDefault(require("../icon/Icon"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../lib/utils");

var _excluded = ["onChange", "value", "placeholders", "onClear"];

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledSearch = (0, _styledComponents["default"])(_Input["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .eui-input-container {\n    background-color: ", ";\n    border-color: ", ";\n\n    &:hover {\n      border-color: ", ";\n    }\n  }\n"])), function (props) {
  return (0, _utils.getPalette)('light', 200)(props);
}, function (props) {
  return (0, _utils.getPalette)('light', 200)(props);
}, function (props) {
  return (0, _utils.getPalette)('primary', 300)(props);
});
var DELAY_AFTER_ANIMATION = 1000;

var getRandomDelayBetween = function getRandomDelayBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

var setPlaceholder = function setPlaceholder(inputNode, placeholder) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Search for ';
  inputNode.setAttribute('placeholder', prefix + placeholder);
};

var animateLetters = function animateLetters(currentLetters, remainingLetters, inputNode, onAnimationEnd, placeholders) {
  if (!remainingLetters.length) {
    return typeof onAnimationEnd === 'function' && onAnimationEnd(currentLetters.join(''), inputNode, placeholders);
  }

  currentLetters.push(remainingLetters.shift());
  setTimeout(function () {
    setPlaceholder(inputNode, currentLetters.join(''));
    animateLetters(currentLetters, remainingLetters, inputNode, onAnimationEnd, placeholders);
  }, getRandomDelayBetween(50, 90));
};

var animatePlaceholder = function animatePlaceholder(inputNode, placeholder, onAnimationEnd, placeholders) {
  animateLetters([], placeholder.split(''), inputNode, onAnimationEnd, placeholders);
};

var onAnimationEnd = function onAnimationEnd(placeholder, inputNode, placeholders) {
  setTimeout(function () {
    var newPlaceholder = placeholders[Math.floor(Math.random() * placeholders.length)];

    do {
      newPlaceholder = placeholders[Math.floor(Math.random() * placeholders.length)];
    } while (placeholder === newPlaceholder);

    animatePlaceholder(inputNode, newPlaceholder, onAnimationEnd, placeholders);
  }, DELAY_AFTER_ANIMATION);
};

function Search(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      placeholders = _ref.placeholders,
      onClear = _ref.onClear,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];

  var _useState3 = (0, _react.useState)(value || ''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      input = _useState4[0],
      setInput = _useState4[1];

  var inputRef = (0, _react.useRef)(null);
  var theme = (0, _styledComponents.useTheme)();

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setInput(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  };

  var handleClear = function handleClear() {
    setInput('');
    onClear === null || onClear === void 0 ? void 0 : onClear();
  };

  (0, _react.useEffect)(function () {
    if (input.length > 0) {
      setToggle(true);
    } else {
      setToggle(false);
    }
  }, [input]);
  (0, _react.useEffect)(function () {
    if (placeholders && placeholders.length > 0) {
      animatePlaceholder(inputRef.current, placeholders[0], onAnimationEnd, placeholders);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(StyledSearch, (0, _extends2["default"])({
    value: input,
    onChange: handleChange,
    ref: inputRef,
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      iconName: "Search",
      fill: (0, _utils.getPalette)('dark', '300')({
        theme: theme
      })
    }),
    endIcon: toggle ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      iconName: 'Close',
      onClick: function onClick() {
        return handleClear();
      },
      fill: (0, _utils.getPalette)('dark', '300')({
        theme: theme
      })
    }) : null
  }, props));
}

Search.defaultProps = {
  placeholders: []
};
Search.propTypes = {
  placeholders: _propTypes["default"].array,
  onChange: _propTypes["default"].func,
  onClear: _propTypes["default"].func,
  value: _propTypes["default"].string
};
var _default = Search;
exports["default"] = _default;